// extracted by mini-css-extract-plugin
export var columnList = "_f6-0";